import { ref } from 'vue';

const SCROLL_OFFSET = -80; // Adjust scroll offset if needed to account for headers

const scrollToPrefilledCategory = (categoryName: string) => {
    // query selector for the element with matching category name. 
    // this uses the contains selector to match any part of the category name
    const elements = document.querySelectorAll(`[data-category*="${categoryName.toLowerCase()}"]`);
    if (elements.length > 0) {

        // get the element with the highest data-products-count attribute value
        let maxProductCount = -1;
        let maxProductElement: Element | null = null;
        let maxProductElementId = '';
        elements.forEach((element: Element) => {
            const productCount = parseInt(element.getAttribute('data-products-count') || '0', 10);
            if (productCount > maxProductCount) {
                maxProductCount = productCount;
                maxProductElement = element;
                maxProductElementId = element.getAttribute('id') || '';
            }
        });
        // console.log(`Element with the highest data-products-count value is "${maxProductElementId}" with ${maxProductCount} products`);

        if (maxProductElement) {
            // Scroll to the element smoothly
            window.scrollTo({
                top: (maxProductElement as HTMLElement).offsetTop + SCROLL_OFFSET,
                behavior: 'smooth',
            });
        } else {
            console.warn(`No elements found with data-products-count attribute.`);
        }
    } else {
        console.warn(`No elements found with data-category="${categoryName}"`);
    }
};

export function usePrefilledCategory() {
    // const route = useRoute();
    // using window.location.href instead of route.query
    const urlParams = new URLSearchParams(window.location.href.split('?')[1]);
    const prefilledCategoryQuery = urlParams.get('prefill_category');

    const prefilledCategory = ref<string | null>(null);
    prefilledCategory.value = prefilledCategoryQuery || null;

    if (!prefilledCategory.value) {
        return { prefilledCategory: null }; // Return early if no prefill category is set
    }

    // trigger scrolling to the prefilled category after a short delay
    setTimeout(() => {
        if (prefilledCategory.value) {
            scrollToPrefilledCategory(prefilledCategory.value);
        }
    }, 500);

}
